import AllPayments from "./AllPayments";

/** /super_admin/contribution/contribution_history_v2: every contribution payment. */
export default function Contribution_HistoryV2() {
  return <AllPayments />;
}
